import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {
  // フッター TOPスクロールボタン
  // document.getElementById("js-scrollTop").addEventListener("click", () => {
  //   gsap.to(window, {
  //     duration: 1,
  //     scrollTo: {
  //       y: 0,
  //       autoKill: false,
  //     },
  //   });
  // });
  // const scrollTopBtn = document.getElementById("js-scrollTop");
  // const target = document.querySelector(".c-mv");

  // const observer = new IntersectionObserver(
  //   (entries) => {
  //     entries.forEach((entry) => {
  //       if (!entry.isIntersecting) {
  //         scrollTopBtn.classList.add("is-show");
  //       } else {
  //         scrollTopBtn.classList.remove("is-show");
  //       }
  //     });
  //   },
  //   {
  //     root: null,
  //     threshold: 0,
  //   }
  // );

  // フェードインアニメーション
  const fadeInElements = document.querySelectorAll(".js-fade-in");
  fadeInElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        y: 30,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power4.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 90%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
  fadeInLeftElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: -30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 80%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
  fadeInRightElements.forEach((element) => {
    gsap.fromTo(
      element,
      {
        opacity: 0,
        x: 30,
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element, // トリガーとなる要素を指定
          start: "top 70%", // スクロール開始位置を指定
          //markers: true,
        },
      }
    );
  });

  // カウントダウン
  document.addEventListener("DOMContentLoaded", () => {
    let counters = document.querySelectorAll(".p-top-counter__number");
    let duration = 1500;

    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let el = entry.target;
            let targetNumber = parseInt(el.textContent.replace(/,/g, ""));
            let startTime = null;

            const countUp = (timestamp) => {
              if (!startTime) startTime = timestamp;
              const progress = timestamp - startTime;
              const rate = Math.min(progress / duration, 1);
              const current = Math.floor(targetNumber * rate);
              el.textContent = current.toLocaleString();

              if (rate < 1) {
                requestAnimationFrame(countUp);
              } else {
                el.textContent = targetNumber.toLocaleString();
              }
            };

            requestAnimationFrame(countUp);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach((counter) => {
      observer.observe(counter);
    });
  });

  // FVタイマーカウントダウン
  document.addEventListener("DOMContentLoaded", () => {
    let countdownEl = document.querySelector(".js-countdown");
    let targetDate = new Date("2025-07-19T11:00:00+09:00");
   
    function updateCountdown() {
     let now = new Date();
     let diff = targetDate - now;
   
     if (diff <= 0) {
      countdownEl.textContent = "開催中！";
      clearInterval(timer);
      return;
     }
   
     let days = Math.floor(diff / (1000 * 60 * 60 * 24));
     let hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
     let minutes = Math.floor((diff / (1000 * 60)) % 60);
     let seconds = Math.floor((diff / 1000) % 60);
   
     countdownEl.innerHTML =
      `<span class="c-mv__number">${days.toString().padStart(2, "0")}</span>日` +
      `<span class="c-mv__number">${hours.toString().padStart(2, "0")}</span>時間` +
      `<span class="c-mv__number">${minutes.toString().padStart(2, "0")}</span>分` +
      `<span class="c-mv__number">${seconds.toString().padStart(2, "0")}</span>秒`;
    }
   
    updateCountdown();
    let timer = setInterval(updateCountdown, 1000);
   });
   


// FV追従ボタン（PC・SP共通対応）
document.addEventListener("DOMContentLoaded", () => {
  let mv = document.querySelector(".c-mv");
  let mvLower = document.querySelector(".c-mv-lower");
  let footer = document.querySelector(".p-footer");
  let fixPc = document.querySelector(".c-fix__buttonsPc");
  let fixSp = document.querySelector(".c-fix__buttonsSp");
 
  const toggleClass = (el, className, add) => {
   if (!el) return;
   el.classList[add ? "add" : "remove"](className);
  };
 
  const handleVisibility = (entry) => {
   if (
    entry.target.classList.contains("c-mv") ||
    entry.target.classList.contains("c-mv-lower")
   ) {
    if (!entry.isIntersecting) {
     toggleClass(fixPc, "is-show", true);
     toggleClass(fixSp, "is-show", true);
    } else {
     const mvInView =
      mv &&
      mv.getBoundingClientRect().top < window.innerHeight &&
      mv.getBoundingClientRect().bottom > 0;
     const mvLowerInView =
      mvLower &&
      mvLower.getBoundingClientRect().top < window.innerHeight &&
      mvLower.getBoundingClientRect().bottom > 0;
     if (mvInView || mvLowerInView) {
      toggleClass(fixPc, "is-show", false);
      toggleClass(fixSp, "is-show", false);
     }
    }
   }
 
   if (entry.target.classList.contains("p-footer")) {
    toggleClass(fixPc, "is-hide", entry.isIntersecting);
    // fixSpは何もしない（消えないようにする）
   }
  };
 
  const observer = new IntersectionObserver(
   (entries) => {
    entries.forEach((entry) => handleVisibility(entry));
   },
   { threshold: 0 }
  );
 
  if (mv) observer.observe(mv);
  if (mvLower) observer.observe(mvLower);
  if (footer) observer.observe(footer);
 });
 



  document.addEventListener("DOMContentLoaded", () => {
    let fbImageContainer = document.querySelector(".uiScaledImageContainer")
   
    if (fbImageContainer) {
     fbImageContainer.removeAttribute("style") // ← style属性ごと削除
    }
   
    let fbImage = document.querySelector(".uiScaledImageContainer img")
   
    if (fbImage) {
     fbImage.removeAttribute("width")
     fbImage.removeAttribute("height")
     fbImage.style.width = "100%"
     fbImage.style.height = "auto"
    }
   })
   



}
